import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllUploadCertificateService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allUploadCertificate = useQuery({
    queryKey: [
      ...CACHE_KEYS.UPLOAD_CERTIFICATES,
      page,
      debouncedQuery,
      per_page,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.UPLOAD_CERTIFICATE,
        searchParams: {
          "filter[partner.name]": debouncedQuery,
          include: "partner,plan,quotable,payment_mode",
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
    // keep polling if any row has status processing
    refetchInterval: (data) => {
      const hasProcessing = data?.state?.data?.data?.some(
        (row: any) => row.status === "processing"
      );
      return hasProcessing ? 3000 : false;
    },
  });

  return {
    services: { allUploadCertificate },
    states: { searchQuery, setSearchQuery },
  };
};
